import UsersContainer from '@Containers/Users/Users.container';

const UsersPage: React.FunctionComponent = (): JSX.Element => (
  <UsersContainer />
);

export default UsersPage;
